module.exports = __webpack_public_path__ + "static/img/bg-index.526f7e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guose/bg-index.png
// module id = FOk3
// module chunks = 1